import React, { useState, useEffect } from 'react';
import { Asset } from '../../../types/asset';
import styled from 'styled-components';
import { Block } from '../../other/block';

const ProjectsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(1, 1fr);

    @media (min-width: 1024px) {
        grid-template-columns: repeat(3, 1fr);
    }
`;

const ImageHolder = styled.div<{ background: string }>(({ background }) => `
    background-image: url(${background});
    background-size: cover;
    max-width: 100%;
    padding-bottom: 100%;
    background-position: center;
`);

interface Project {
    title: string;
    content: string;
    type?: string;
    background: Asset;
    }

interface ProjectProps {
    heading: string;
    layout: string;
    projects: Project[];
    backgroundColour?: string;
}

export const ProjectCollection: React.FC<ProjectProps> = ({ heading, layout, projects, backgroundColour }) => {
    const [isMobile, setIsMobile] = useState(false);

    const totalProjects = projects.length;

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        setIsMobile(window.innerWidth <= 640);

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 640);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    if (layout === 'Full Width') {
        const maps = [
            'row-span-4 col-span-4',
            'row-span-2 col-span-4 md:col-span-3',
            'row-span-2 col-span-4 md:col-span-3',
            'row-span-2 col-span-4 md:col-span-3',
            'row-span-4 col-span-4',
            'row-span-2 col-span-4 md:col-span-3',
        ];

        return (
            <div className={'border-b border-black'}>
                <div className={'py-16 md:py-20 max-w-6xl mx-auto'}>
                    <div className="grid grid-flow-row grid-cols-1 gap-4 px-12 md:grid-cols-7">
                        {projects.map((project, index) => {

                            let itemHeight = '';

                            if (isMobile) {
                                itemHeight = '100%';
                            } else {
                                itemHeight = maps[index] === 'row-span-4 col-span-4' ? '892px' : '100%';
                            }

                            return (
                            <div
                                key={index}
                                className={`${maps[index]} bg-cover bg-center`}
                                style={{
                                    height: itemHeight,
                                    backgroundImage: `linear-gradient(rgba(60, 60, 60, 0.6) 10%, rgba(60, 60, 60, 0)), url(${project.background.url})`,
                                }}
                            >
                                <div className={'p-6'}>
                                    <div className="text-2xl text-left text-white font-playfair">
                                        {project.title}
                                    </div>
                                    <div className="mt-2 text-base text-white md:px-0">
                                        <p>{project.content}</p>
                                    </div>
                                </div>
                            </div>
                        ); })}
                    </div>
                </div>
            </div>
        );
    }
    return (
    <Block backgroundColour={backgroundColour}>
        <h2 className="text-center text-1.5xl mb-8 uppercase">{heading}</h2>
        <div className="mx-auto max-w-7xl">
                <ProjectsContainer className={`grid grid-cols-1 grid-rows-1 gap-12 px-12 mx-auto sm:grid-cols-3`}>
                {projects.map((project, index) => (
                    <div key={index} className="relative ">
                        <ImageHolder background={project.background.url} />
                        <div className="mt-5 text-3xl font-medium font-playfair">
                            {project.title}
                        </div>
                        <div className="mt-3 text-base">
                            <p>{project.content}</p>
                        </div>
                        {project.type && (
                            <div
                                className="absolute top-0 right-0 px-2 py-1 text-base uppercase bg-white border border-stone"
                            >
                                {project.type}
                            </div>
                            )
                        }
                    </div>
                ))}
            </ProjectsContainer>
        </div>
    </Block>
    );
};
